import { PlainBlock } from "@/sanity.types";
import { PortableText } from "next-sanity";
import bg from "@assets/images/tech_feat_illu/mobile/bg.svg";
import bg2 from "@assets/images/tech_feat_illu/mobile/bg2.svg";
import logo from "@assets/images/tech_feat_illu/mobile/logo.svg";
import logo2 from "@assets/images/tech_feat_illu/mobile/logo2.svg";
import first from "@assets/images/tech_feat_illu/mobile/first.svg";
import second from "@assets/images/tech_feat_illu/mobile/second.svg";
import circles from "@assets/images/tech_feat_illu/mobile/circles.svg";
import circles2 from "@assets/images/tech_feat_illu/mobile/circles2.svg";
import Image from "next/image";
import clsx from "clsx";
import { motion } from "framer-motion";

const MobileTile = ({ feature, index }: { feature: { featureDescription?: PlainBlock; _type: string; _key: string }; index: number }) => {
	return (
		<div className="flex flex-col gap-y-7">
			<div
				className={clsx(index % 2 === 0 ? "aspect-[219/166]" : "aspect-[219/195]", "relative grid w-full grid-cols-1 grid-rows-1")}
			>
				{index % 2 === 0 ? (
					<Image src={bg} fill alt="Background" className="overflow-hidden rounded-[1.25rem] object-cover" />
				) : (
					<Image src={bg2} fill alt="Background" className="overflow-hidden rounded-[1.25rem] object-cover" />
				)}
				{index % 2 === 0 ? (
					<Image src={circles} fill alt="Circles" className="pulse object-cover" />
				) : (
					<Image src={circles2} fill alt="Circles" className="pulse object-cover" />
				)}
				<motion.div
					initial={{ opacity: 0, y: "2rem" }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ amount: "some", margin: "-45% 0% -40% 0%" }}
				>
					{index % 2 === 0 ? (
						<Image src={first} fill alt="First" className="object-cover" />
					) : (
						<Image src={second} fill alt="Second" className="object-cover" />
					)}
				</motion.div>
				{index % 2 === 0 ? (
					<Image src={logo} fill alt="Logo" className="object-cover" />
				) : (
					<Image src={logo2} fill alt="Logo" className="object-cover" />
				)}
			</div>
			<div className="whitespace-pre-wrap font-secondary text-[#717171] [&>p]:pb-6 [&_li]:ml-6 [&_li]:list-disc [&_li]:pl-2 [&_strong]:font-secondary-semibold [&_strong]:font-medium [&_strong]:text-black">
				<PortableText value={feature.featureDescription || []} />
			</div>
		</div>
	);
};

export default MobileTile;
